import axios from 'axios';
import { makeAutoObservable, runInAction } from 'mobx';
import { store } from './store';
import agent from '../services/api/agent';
import { INewPageModel } from '../services/models/CourseViewModels';
import { base64ToFile } from '../utils/toFile';
import { EContentType, IPagePlaceholder } from '../services/models/PageViewModel';
import { EEnquiryContentType } from '../services/models/enquiry/EnquiryContentObjectModel';
import { v4 as uuidv4 } from 'uuid';
import { TOwnerCourseViewModel } from '../services/models/OwnerViewModel';
import { IPropertyValue } from '../services/models/PropertyViewModel';

const apiKey = process.env.REACT_APP_OPENAI_API_KEY;

export default class OpenAIStore {
  creationProcess: string[] = [
    /*     'Making request to Open API',
    'Creating Course - The Art of Bread Making',
    'Creating Page 0 - Introduction',
    'Creating Text at page Introduction',
    'Creating Page 1 - Ingredients',
    'Creating Text at page Ingredients',
    'Creating Image at page Ingredients',
    'Creating Page 2 - Mixing and Kneading the Dough',
    'Creating Text at page Mixing and Kneading the Dough',
    'Creating Image at page Mixing and Kneading the Dough',
    'Creating Page 3 - Resting and Rising',
    'Creating Text at page Resting and Rising',
    'Creating Image at page Resting and Rising',
    'Creating Page 4 - Shaping and Baking',
    'Creating Text at page Shaping and Baking',
    'Creating Text at page Shaping and Baking',
    'Done', */
  ];
  constructor() {
    makeAutoObservable(this);
  }

  /*   requestData = {
    //model: 'gpt-4',
    model: 'gpt-3.5-turbo',
    messages: [
      {
        role: 'system',
        content: 'You are a E-learning course developer, and you are creating a course.',
      },
      {
        role: 'system',
        content: 'The pages should consist of two columns. One column with HTML text, and one column with an image.',
      },
      {
        role: 'system',
        content: 'The html must be formatted with headers, paragraphs, lists and other html elements thats needed.',
      },
      {
        role: 'system',
        content: 'When you use an image, provide a description in great detail of what the image looks like in the imageDetail parameter.',
      },
      {
        role: 'system',
        content:
          'At the end of the course, add 2 pages with questions based on the previous pages. The questions must have 3 alternatives and the correct_aswer parameter should be the index of the correct answer and an image.',
      },
      {
        role: 'system',
        content:
          'The response must all be in a json structure that must fit inside this model: interface AICourse{course_title:string;course_description:string;pages:AIPage[]}interface AIPage{page_title:string;contents:AIContent[]}interface AIContent{image?:AIImage;text?:AIText;question?:AIQuestion}interface AIText{html:string}interface AIImage{imageDescription:string}interface AIQuestion{question:string;options:string[];correct_answer:string}',
      },
      {
        role: 'system',
        content: 'The column type must reflect what content is in that column.',
      },
      {
        role: 'system',
        content: 'Create a course about:',
      },
      {
        role: 'user',
        content: 'Et kurs som handler om å lage donuts',
      },
      {
        role: 'system',
        content: 'Place the html content inside a div element and format it as it would be if presented on a website.',
      },
      {
        role: 'system',
        content: 'The response must be only ',
      },
      {
        role: 'system',
        content:
          'The returned JSON structure MUST be minified with no whitespaces, indents and linebreaks in the json structure. Make sure the response is nothing else than the JSON structure, nothing before or after.',
      },
      {
        role: 'system',
        content: 'The response must be in the language the user wrote in, unless otherwise stated.',
      },
    ],
  }; */

  requestData = {
    //model: 'gpt-4',
    model: 'gpt-3.5-turbo',
    messages: [
      {
        role: 'system',
        content: 'You are a course developer, and an expert in creating E-learning courses on any topic.',
      },
      {
        role: 'system',
        content: 'You will be given a topic, and based on that topic you will create exactly 5 chapters.',
      },
      {
        role: 'system',
        content: 'Every chapter must have content. This content should be text accompanied with an image.',
      },
      {
        role: 'system',
        content: 'The text must be structured with at least one header element. The rest of the text can be either paragraph or other HTML elements like lists, tables etc. Make sure its pure HTML',
      },
      {
        role: 'system',
        content: 'In adittion to the content, every chapter MUST have 3 pages about the chapter topic. The content on the pages should be text accompanied with an image.',
      },
      {
        role: 'system',
        content: 'The chapters must be in a logical order considering the topic.',
      },
      {
        role: 'system',
        content: 'At the end of the course, there should be a quiz chapter with one page for every chapter. The content on these pages should be questions and images.',
      },
      {
        role: 'system',
        content: 'The language of the course should match the input given.',
      },
      {
        role: 'system',
        content: 'Your input will be a description of a topic that varies length. If the input does not include a description of a topic, then return nothing.',
      },
      {
        role: 'system',
        content: 'Your outbust MUST ALWAYS be in valid JSON format following the example output structure. EXAMPLE:',
      },
      {
        role: 'system',
        content: 'INPUT: Cybersecurity for employees',
      },
      {
        role: 'system',
        content:
          'OUTPUT: {"courseTitle":"Cybersecurity for Employees","courseDescription":"Description of the Course","chapters":[{"chapterTitle":"Introduction to Cybersecurity","content":[{"type":"text","text":"<p>In today\'s interconnected digital world, cybersecurity awareness is paramount. This chapter introduces the significance of understanding and practicing good cybersecurity.</p><p>Cybersecurity is not just an IT issue; it\'s everyone\'s concern. Learn why it\'s crucial to stay informed and vigilant in the face of evolving cyber threats.</p>"},{"type":"image","imageDescription":"An illustration of Cybersecurity."}],"pages":[{"pageTitle":"The Cyber Threat Landscape","content":[{"type":"text","text":"<p>Cyber threats come in various forms, from phishing emails to ransomware attacks. This page explores common cyber threats, providing real-life examples to illustrate their impact and relevance.</p>"},{"type":"image","imageDescription":"An illustration of a computer screen with multiple warning messages and a lock symbol representing cyber threats."}]}]},{"chapterTitle":"Cyber Hygiene","content":[{"type":"text","text":"<p>Establishing a strong foundation in cyber hygiene is essential. This page covers fundamental practices, including password security and the importance of two-factor authentication (2FA).</p><p>Your first line of defense against cyber threats starts with secure passwords and 2FA. Discover how these practices can significantly enhance your online security.</p>"},{"type":"image","imageDescription":"An illustration of Cyber Hygiene"}],"pages":[{"pageTitle":"Cyber Hygiene Basics","content":[{"type":"text","text":"<p>Establishing a strong foundation in cyber hygiene is essential. This page covers fundamental practices, including password security and the importance of two-factor authentication (2FA).</p><p>Your first line of defense against cyber threats starts with secure passwords and 2FA. Discover how these practices can significantly enhance your online security.</p>"},{"type":"question","question":{"questionText":"Why is it important to have strong passwords and use two-factor authentication (2FA) for online security?","options":["Strong passwords and 2FA help prevent unauthorized access.","They make your computer run faster.","They improve your internet connection."],"correctAnswer":0}}]},{"pageTitle":"Email Security and Safe Browsing","content":[{"type":"text","text":"<p>Email is a common vector for cyberattacks. Here, we delve into email security best practices, helping you recognize and defend against phishing emails. Additionally, we explore safe browsing habits to protect your online activities.</p>"},{"type":"image","imageDescription":"An illustration showing an inbox with phishing emails marked as suspicious."},{"type":"question","question":{"questionText":"What are some common signs of a phishing email, and how can you protect yourself from falling victim to such attacks?","options":["Click on all links in the email to verify their authenticity.","Download any attachments immediately.","Be cautious of unexpected emails and verify sender addresses."],"correctAnswer":2}}]}]}]}',
      },
    ],
  };

  apiUrl = 'https://api.openai.com/v1/chat/completions';

  makeApiRequest = (prompt: string) => {
    this.requestData.messages.push({ role: 'user', content: prompt });
    this.creationProcess.push('Making request to Open AI');

    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.requestData),
    };

    fetch(this.apiUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Handle the OpenAI API response data here
        console.log(data);
        const course: Course = JSON.parse(data.choices[0].message.content);
        this.createCourseFromAIResponse(course);
      })
      .catch((error) => {
        // Handle errors
        console.error('Error:', error);
      });
  };

  dalleApiUrl = 'https://api.openai.com/v1/images/generations';
  dalleApiRequest = async (prompt: string): Promise<File | null> => {
    this.creationProcess.push('Making request to Open AI for Image');
    try {
      const response = await fetch(this.dalleApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + apiKey,
        },
        body: JSON.stringify({
          prompt: prompt,
          n: 1,
          size: '256x256',
          response_format: 'b64_json',
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.data && data.data.length > 0 && data.data[0].b64_json) {
        const file = base64ToFile(data.data[0].b64_json, 'gptImage' + uuidv4() + '.png', 'image/png');
        return file;
      } else {
        console.error('No valid data received from the API.');
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  createCourseFromAIResponse = async (aCourse: Course) => {
    this.creationProcess.push('Creating Course - ' + aCourse.courseTitle);
    const coursePayload = { '1': aCourse.courseTitle, '2': aCourse.courseDescription, '57': '1280', '58': '720', '83': '' };
    const newCourse = await store.ownerStore.createCourse(coursePayload);
    if (newCourse === undefined) return;

    let index = 1;

    for (let i = 0; i < aCourse.chapters.length; i++) {
      const chapter = aCourse.chapters[i];
      this.creationProcess.push('Creating chapter ' + i + ' - ' + chapter.chapterTitle);

      const chapterPage = await this.createPage(newCourse, 'chapter - ' + chapter.chapterTitle, chapter.content.length, index);
      index++;
      for (let j = 0; j < chapter.content.length; j++) {
        const content = chapter.content[j];
        this.createContent(newCourse, chapter.chapterTitle, chapterPage.coursePageID, chapterPage.placeholders[j].pagePlaceholderID, content);
      }

      for (let y = 0; y < chapter.pages.length; y++) {
        const page = chapter.pages[y];
        this.creationProcess.push('Creating page ' + y + ' - ' + page.pageTitle);
        const pagePage = await this.createPage(newCourse, 'page - ' + page.pageTitle, page.content.length, index);
        index++;
        for (let u = 0; u < page.content.length; u++) {
          const content = page.content[u];
          this.createContent(newCourse, page.pageTitle, pagePage.coursePageID, pagePage.placeholders[u].pagePlaceholderID, content);
        }
      }
    }

    /*     for (let i = 0; i < aCourse.pages.length; i++) {
      const pageElement = aCourse.pages[i];
      this.creationProcess.push('Creating Page ' + i + ' - ' + pageElement.page_title);
      const newPageRequest: INewPageModel = { courseID: newCourse.courseID, parentCoursePageID: undefined, index: i + 1, title: pageElement.page_title, templateNo: 0 };
      const newPage = await agent.Course.newPage(newPageRequest);
      const pageLayout = layoutList[pageElement.contents.length];
      await agent.Page.changePageLayout(newPage.courseID, newPage.coursePageID, pageLayout);
      const page = await agent.Page.getPage(newPage.courseID, newPage.coursePageID);

      for (let y = 0; y < aCourse.pages[i].contents.length; y++) {
        const element = aCourse.pages[i].contents[y];
        const keys = Object.keys(element);
        let newImage: File | null;
        switch (keys[0]) {
          case 'image':
            this.creationProcess.push('Creating Image at ' + pageElement.page_title);
            if (element.image === undefined) return;
            newImage = await this.dalleApiRequest(element.image.imageDescription);
            if (newImage !== null)
              this.uploadAndCreateSingleImage(newCourse.courseID, newPage.coursePageID, page.placeholders[y].pagePlaceholderID, newImage, 'OpenAI', element.image.imageDescription);
            break;
          case 'text':
            if (element.text === undefined) return;
            this.creationProcess.push('Creating Text at ' + pageElement.page_title);
            await this.createText(newCourse.courseID, newPage.coursePageID, page.placeholders[y].pagePlaceholderID, element.text.html);
            break;
          case 'question':
            if (element.question === undefined) return;
            this.creationProcess.push('Creating Question at ' + pageElement.page_title);
            await this.createNewQuestion(EEnquiryContentType.singleAlternative, newCourse.courseID, newPage.coursePageID, page.placeholders[y].pagePlaceholderID, element.question);
            break;
          default:
            break;
        }
      }
    } */
    //
    this.creationProcess.push('Done');
  };

  createPage = async (newCourse: TOwnerCourseViewModel, title: string, contentLength: number, index: number, parentID?: number) => {
    const newPageRequest: INewPageModel = { courseID: newCourse.courseID, parentCoursePageID: parentID, index: index + 1, title: title, templateNo: 0 };
    const newPage = await agent.Course.newPage(newPageRequest);
    const pageLayout = layoutList[contentLength];
    await agent.Page.changePageLayout(newPage.courseID, newPage.coursePageID, pageLayout);
    return await agent.Page.getPage(newPage.courseID, newPage.coursePageID);
  };

  createContent = async (newCourse: TOwnerCourseViewModel, title: string, coursePageID: number, pagePlaceholderID: number, contents: Content) => {
    //const keys = Object.keys(contents);

    let newImage: File | null;
    switch (contents.type) {
      case 'image':
        this.creationProcess.push('Creating Image at page ' + title);
        if (contents.imageDescription === undefined) return;
        newImage = await this.dalleApiRequest(contents.imageDescription);
        if (newImage !== null) this.uploadAndCreateSingleImage(newCourse.courseID, coursePageID, pagePlaceholderID, newImage, 'OpenAI', contents.imageDescription);
        break;
      case 'text':
        if (contents.text === undefined) return;
        this.creationProcess.push('Creating Text at page ' + title);
        await this.createText(newCourse.courseID, coursePageID, pagePlaceholderID, contents.text);
        break;
      case 'question':
        if (contents.question === undefined) return;
        this.creationProcess.push('Creating Question at page ' + title);
        await this.createNewQuestion(EEnquiryContentType.singleAlternative, newCourse.courseID, coursePageID, pagePlaceholderID, contents.question);
        break;
      default:
        break;
    }
  };

  //
  //
  //
  //
  //
  //
  //
  //
  //

  uploadAndCreateSingleImage = async (aCourseID: number, aCoursePageID: number, pagePlaceholderID: number, file: File, folder: string, aAltText: string) => {
    store.mediaLibraryStore.uploadImage(file, folder, aAltText).then((response) => {
      if (response.url !== '') {
        const extension = /.[0-9a-z]+$/.exec(file.name);
        if (extension === null) return;

        this.createImage(response.url, aCourseID, aCoursePageID, pagePlaceholderID, aAltText);
      }
    });
  };

  createImage = async (src: string, aCourseID: number, aCoursePageID: number, pagePlaceholderID: number, aImgAltText: string) => {
    const newContent = await this.newContent(aCourseID, aCoursePageID, pagePlaceholderID, EContentType.Image);
    if (newContent === undefined) return;
    const contentProperties = await agent.Page.GetPagePlaceholderContentProperties(aCourseID, aCoursePageID, pagePlaceholderID, newContent.contentID);

    const propertyList: IPropertyValue[] = [
      { propertyValueView: contentProperties.CSS.items.objectFit, value: 'cover' },
      { propertyValueView: contentProperties.CSS.items.objectPosition, value: '50% 50%' },
      { propertyValueView: contentProperties.image.items.altText, value: aImgAltText },
    ];
    //store.propertyStore.setOptionList(propertyList);

    newContent.innerHTML = src;

    runInAction(() => {
      newContent.CSS.objectFit = 'cover';
      newContent.CSS.objectPosition = '50% 50%';

      if (newContent.image?.altText !== undefined) {
        newContent.image.altText = aImgAltText;
      }
    });

    store.pageStore.updateContent(newContent);
    return newContent;
  };

  createText = async (aCourseID: number, aCoursePageID: number, pagePlaceholderID: number, content: string) => {
    const newContent = await this.newContent(aCourseID, aCoursePageID, pagePlaceholderID, EContentType.TextDynamic);
    if (newContent === undefined) return;

    /*     const placeholderProperties = await agent.Page.GetPagePlaceholderProperties(aCourseID, aCoursePageID, pagePlaceholderID);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingLeft.propertyValueID, store.pageStore.defaultTextPadding);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingRight.propertyValueID, store.pageStore.defaultTextPadding);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingTop.propertyValueID, store.pageStore.defaultTextPadding);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingBottom.propertyValueID, store.pageStore.defaultTextPadding); */

    newContent.innerHTML = content;
    store.pageStore.updateContent(newContent);
  };

  newContent = async (aCourseID: number, aCoursePageID: number, pagePlaceholderID: number, coursePageContentType: EContentType) => {
    const newContent = await agent.Page.NewContent(aCourseID, aCoursePageID, pagePlaceholderID, coursePageContentType.valueOf());
    return newContent;
  };

  createNewQuestion = async (enquiryContentType: EEnquiryContentType, aCourseID: number, aCoursePageID: number, pagePlaceholderID: number, aQuestion: Question) => {
    const newContent = await agent.Page.NewQuestion(aCourseID, aCoursePageID, pagePlaceholderID, enquiryContentType);

    /*     const placeholderProperties = await agent.Page.GetPagePlaceholderProperties(aCourseID, aCoursePageID, pagePlaceholderID);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingLeft.propertyValueID, store.pageStore.defaultTextPadding);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingRight.propertyValueID, store.pageStore.defaultTextPadding);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingTop.propertyValueID, store.pageStore.defaultTextPadding);
    store.pageStore.setOption(placeholderProperties.colorAndDesign.items.paddingBottom.propertyValueID, store.pageStore.defaultTextPadding); */

    console.log(newContent);
    if (newContent === undefined) return;
    newContent.innerHTML = aQuestion.questionText;

    newContent.enquiryContent.question.singleAlternative.alternatives[0].innerHTML = aQuestion.options[0];
    newContent.enquiryContent.question.singleAlternative.alternatives[1].innerHTML = aQuestion.options[1];
    newContent.enquiryContent.question.singleAlternative.alternatives[2].innerHTML = aQuestion.options[2];

    await store.pageStore.updateContent(newContent.enquiryContent.question.singleAlternative.alternatives[0]);
    await store.pageStore.updateContent(newContent.enquiryContent.question.singleAlternative.alternatives[1]);
    await store.pageStore.updateContent(newContent.enquiryContent.question.singleAlternative.alternatives[2]);
    await store.pageStore.updateContent(newContent);
  };
}

interface layList {
  [key: number]: number;
  1: number;
  2: number;
  3: number;
  4: number;
}
const layoutList: layList = { 1: 1, 2: 3, 3: 7, 4: 11 };

// new course payload {"1":"test","2":"123321","57":"1280","58":"720","83":""}
//new page:
//const newPageRequest: INewPageModel = { courseID: this.courseViewModel.courseID, parentCoursePageID: undefined, index: index, title: 'New Page', templateNo: 0 };
//const newPage = await agent.Course.newPage(newPageRequest);
//change layout store.pageStore.changePageLayout
interface Course {
  courseTitle: string;
  courseDescription: string;
  chapters: Chapter[];
}

interface Chapter {
  chapterTitle: string;
  content: Content[];
  pages: Page[];
}

interface Page {
  pageTitle: string;
  content: Content[];
}

interface Content {
  type: string;
  text?: string;
  imageDescription?: string;
  question?: Question;
}

interface Question {
  questionText: string;
  options: string[];
  correctAnswer: number | null;
}
